
/******/ (() => {
  /* eslint-disable */
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();

      this.onSwatchChangeBound = this.onSwatchChange.bind(this);
      this.onColorSwatchMouseEnterBound = this.onColorSwatchMouseEnter.bind(this);
      this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
    }

    connectedCallback() {
      this.colorLabelContainer = this.querySelector('[data-color-swatch-name-container]');
      this.colorLabel = this.querySelector('[data-color-swatch-name]');
      this.colorLabelState = this.querySelector('[data-color-swatch-state]');
      this.soldOutString = this.getAttribute('data-swatch-sold-out-string');
      this.colorSwatches = this.querySelectorAll('.swatch-element.color');
      this.sectionId = this.getAttribute('data-section-id');

      this.setEventListeners();
      this.setColorLabelState();
    }

    setEventListeners() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
        swatch.addEventListener('mouseleave', this.onSwatchMouseLeaveBound);

      //   // 🔒 Blocca il click per gli swatch soldout
      //   if (swatch.classList.contains('soldout')) {
      //     const input = swatch.querySelector('input[type="radio"]');
      //     if (input) {
      //       input.addEventListener('click', (e) => {
      //         e.preventDefault();
      //         e.stopPropagation();
      //       });
      //     }
      //   }
      });

      this.addEventListener('change', this.onSwatchChangeBound);
    }

    setColorLabelState() {
      const activeSwatch = this.querySelector('.swatch-element.color.active');
      if (!activeSwatch) return;

      const activeSwatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
      if (!this.soldOutString || !this.colorLabelState) return;

      this.updateColorLabelState(activeSwatchAvailable);
      this.currentLabel = this.colorLabel ? this.colorLabel.textContent : '';
    }

    updateColorLabelState(available) {
      if (this.colorLabelState) {
        this.colorLabelState.innerText = available === 'false' ? `(${this.soldOutString})` : '';
      }
    }

    onSwatchChange(event) {
      const input = event.target;
      const currentVariant = this.getVariantData(input.id);
      const productUrl = input.getAttribute('data-product-url');
      const productFetchUrl = input.getAttribute('data-product-fetch-url');
      const isCombinedListing = input.getAttribute('data-is-combined-listing') === 'true';

      const selectedVariantId = input.closest('[data-swatch-variant-id]')?.dataset.swatchVariantId;

      const form = input.closest('form');
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = selectedVariantId;
        }
      }

      this.querySelectorAll('.swatch-element').forEach(el => {
        el.classList.remove('active');
        const radio = el.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
      });

      const swatch = input.closest('.swatch-element');
      if (swatch) {
        swatch.classList.add('active');
        input.checked = true;
      }

      this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);
    }

    emitVariantChangeEvent(variant, productFetchUrl, productUrl, isCombinedListing = false) {
      eventBus.emit('variant:change', {
        sectionId: this.sectionId,
        variant: variant,
        fetchURL: productFetchUrl,
        productURL: productUrl,
        isCombinedListing: isCombinedListing
      });
    }

    onColorSwatchMouseEnter(event) {
      this.updateColorLabel(event.currentTarget);

      const activeSwatch = this.querySelector('.swatch-element.color.active');
      if (activeSwatch && !event.currentTarget.classList.contains('active')) {
        activeSwatch.classList.add('sibling-hover-active');
      }
    }

    onSwatchMouseLeave() {
      const siblingHoverActiveSwatch = this.querySelector('.swatch-element.sibling-hover-active');
      if (siblingHoverActiveSwatch) {
        siblingHoverActiveSwatch.classList.remove('sibling-hover-active');
      }

      this.resetColorLabel();
    }

    updateColorLabel = (swatch) => {
      if (!swatch) return;
      const label = swatch.getAttribute('data-value');
      const swatchAvailable = swatch.getAttribute('data-swatch-option-available');

      if (!label || !this.colorLabel) return;

      this.colorLabel.textContent = label;
      this.animateColorLabel(label);
      this.updateColorLabelState(swatchAvailable);
    }

    resetColorLabel = () => {
      const activeSwatch = this.querySelector('.swatch-element.color.active');
      if (!activeSwatch || !this.colorLabel) return;

      const activeSwatchValue = activeSwatch.getAttribute('data-value');
      const swatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
      if (!activeSwatchValue) return;

      this.colorLabel.textContent = activeSwatchValue;
      this.animateColorLabel(activeSwatchValue);
      this.updateColorLabelState(swatchAvailable);
    }

    animateColorLabel(label) {
      if (label === this.currentLabel) return;

      this.colorLabelContainer.classList.remove('fade-in-label');
      void this.colorLabelContainer.offsetWidth;
      this.colorLabelContainer.classList.add('fade-in-label');
      this.currentLabel = label;
    }

    removeEventListeners() {
      this.colorSwatches.forEach(swatch => {
        swatch.removeEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
        swatch.removeEventListener('mouseleave', this.onSwatchMouseLeaveBound);
      });

      this.removeEventListener('change', this.onSwatchChangeBound);
    }

    getVariantData(inputId) {
      return JSON.parse(this.getVariantDataElement(inputId).textContent);
    }

    getVariantDataElement(inputId) {
      return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }
  }

  if (!window.customElements.get('product-swatch')) {
    window.customElements.define('product-swatch', ProductSwatch);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.eventBus) return;

    eventBus.on('variant:change', ({ variant, sectionId }) => {
      if (!variant || !variant.id) return;

      const section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!section) return;

      const form = section.querySelector('form[action*="/cart/add"]');
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = variant.id;
          console.log('Variante aggiornata nel form da eventBus:', variant.id);
        }
      }

      if (variant?.id && sectionId) {
        updateProductMediaGridWithGalleryByAJAX(variant.id, sectionId);
      }
    });
  });

  function updateProductMediaGridWithGalleryByAJAX(variantId, sectionId) {
    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const newMediaGrid = tempDiv.querySelector('product-media-grid');
        const currentMediaGrid = document.querySelector('product-media-grid');

        if (newMediaGrid && currentMediaGrid) {
          currentMediaGrid.replaceWith(newMediaGrid);
          console.log('Galleria aggiornata via AJAX per variante', variantId);
        }
      })
      .catch(err => console.error('Errore durante l\'aggiornamento della galleria:', err));
  }
/******/ })();
